import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OptiActions, OptiActitonTypes } from './opti.actions';
import { OptiData } from '../../_models/opti_data';
import { OptiPiece } from '../../_models/opti_piece';
import { OptiSheet } from '../../_models/opti_sheet';

export interface State extends fromRoot.State {
	movements: OptiState;
}

export interface OptiState {
	optiList: OptiData[];
	compactList: any;
	lotStudy: any;
	divideLotList: any;
	currentOpti: OptiData;
	chargeOpti: OptiPiece[];
	chargeSheetOpti: OptiSheet[];
	retalList: OptiPiece[];
    sizeList: any;
	filterFields: any[];
	loadingOpti: boolean;
	error: string;
}

const initialOptiItem: OptiData = {
	id: null,
  	od_user_id: null,
  	od_batch_date: null,
  	od_cut_start_date: null,
  	od_cut_end_date: null,
  	od_batch_number: null,
  	od_opti_group: null,
  	od_product_id: null,
  	od_width: null,
  	od_height: null,
  	od_depth: null,
  	od_stock_plates_number: null,
  	od_product_desc: null,
  	od_net_area: null,
  	od_gross_area: null,
  	od_porcentage_wastage: null,
  	od_optimization_time: null,
  	od_oef_used: null,
  	od_oef_phase: null,
  	od_oef_preset: null,
  	od_oef_summary: null,
  	od_net_area_weight: null,
  	od_customers_number:null,
  	od_customers: null,
  	od_total_pieces: null,
  	od_total_easels: null,
  	od_configuration: null,
  	od_opti_number: null,
  	od_lots_number: null,
  	od_notes: null,
  	od_state: null,
    od_layout_snapshot: null
};

const initialState: OptiState = {
	currentOpti: null,
	chargeOpti: [],
	chargeSheetOpti: [],
	retalList: [],
	optiList: [],
	compactList: [],
	lotStudy: [],
	divideLotList: [],
    sizeList: null,
	filterFields: [],
	loadingOpti: false,
	error: ''
};

const getOptiFeatureState = createFeatureSelector<OptiState>('opti');

export const getSizesList = createSelector(
  getOptiFeatureState,
  state => state.sizeList
);

export const getCurrentOpti = createSelector(
	getOptiFeatureState,
	state => state.currentOpti
);

export const getChargeOpti = createSelector(
	getOptiFeatureState,
	state => state.chargeOpti
);

export const getChargeSheetOpti = createSelector(
	getOptiFeatureState,
	state => state.chargeSheetOpti
);

export const getOptiList = createSelector(
	getOptiFeatureState,
	state => state.optiList
);

export const getCompactList = createSelector(
	getOptiFeatureState,
	state => state.compactList
);

export const getLotStudy = createSelector(
	getOptiFeatureState,
	state => state.lotStudy
);

export const getDivideLotList = createSelector(
	getOptiFeatureState,
	state => state.divideLotList
);

export const getRetalOptiList = createSelector(
	getOptiFeatureState,
	state => state.retalList
);

export const getFilterFields = createSelector(
	getOptiFeatureState,
	state => state.filterFields
);

export const getLoadingOpti = createSelector(
	getOptiFeatureState,
	state => state.loadingOpti
);

export const getError = createSelector(
	getOptiFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: OptiActions): OptiState {

	// console.log('--> Movement Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Movement type: ');
	// console.log(action.type);

	switch (action.type) {
		
		case OptiActitonTypes.ClearOpti:

			console.log('--> Entrando en acción ClearOpti.');

			return {
					...state,
					currentOpti: null,
					chargeOpti: [],
					chargeSheetOpti: []
				};


		case OptiActitonTypes.InicializeOpti:

			console.log('--> Entrando en acción InicializeOpti.');

			state = initialState;

			return state;
			

		case OptiActitonTypes.SetFilterFields:

			console.log('--> Entrando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

    case OptiActitonTypes.LoadSizesSuccess:

      console.log('--> Entrando en acción LoadSizesSuccess. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        sizeList: action.payload,
        error: ''
      };

    case OptiActitonTypes.LoadSizesFail:

      console.log('--> Entrando en acción LoadSizesFail. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        sizeList: [],
        error: action.payload
      };
      
      case OptiActitonTypes.CompactOptiSuccess:

			console.log('--> Entrando en acción CompactOptiSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					compactList: action.payload,
					error: ''
				};

	  case OptiActitonTypes.CompactOptiFail:

			console.log('--> Entrando en acción CompactOptiFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					compactList: [],
					error: action.payload
				};
				
	  case OptiActitonTypes.LotStudySuccess:

			console.log('--> Entrando en acción LotStudySuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					lotStudy: action.payload,
					error: ''
				};

	  case OptiActitonTypes.LotStudyFail:

			console.log('--> Entrando en acción LotStudyFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					lotStudy: [],
					error: action.payload
				};
				
      
      case OptiActitonTypes.LoadOpti:

			return {
					...state,
					loadingOpti: true,
					error: ''
				};

      case OptiActitonTypes.LoadOptiSuccess:

			console.log('--> Entrando en acción CompactOptiSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					optiList: action.payload,
					loadingOpti: false,
					error: ''
				};

	  case OptiActitonTypes.LoadOptiFail:

			console.log('--> Entrando en acción LoadOptiFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					optiList: [],
					loadingOpti: false,
					error: action.payload
				};
				
	  case OptiActitonTypes.SaveOptiPieceSuccess:

			console.log('--> Entando en acción SaveOptiPieceSuccess. => Payload = ');
			console.log(action.payload);
			
			// IMPORTANTE: Para llamar webservice de VS-Stock usando Fetch nativo.
		    // Usando la solicitud por defecto GET.
		    // window.fetch('http://betawebapp.vidrioservice.com:8079/api/create_remnant_opti?pax=331122&usx=oracle&opti=' + action.payload)
			// .then((response) => response.json())
			// .then((json) => console.log(json));

			return {
					...state,
					currentOpti: action.payload,
					error: ''
				};

		case OptiActitonTypes.SaveOptiPieceFail:

			console.log('--> Entando en acción SaveOptiPieceFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					currentOpti: null,
					error: action.payload
				};
	
	  case OptiActitonTypes.LoadRetalOptiSuccess:

			console.log('--> Entrando en acción LoadRetalOptiSuccess. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					retalList: action.payload,
					error: ''
				};

	  case OptiActitonTypes.LoadRetalOptiFail:

			console.log('--> Entrando en acción LoadRetalOptiFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					retalList: [],
					error: action.payload
				};
				
	  case OptiActitonTypes.ChargeOptiSuccess:

			console.log('--> Entrando en acción ChargeOptiSuccess. => Payload = ');
			console.log(action.payload);
			
			let pieces = action.payload['pieces'];
			let sheets = action.payload['sheets'];
			let loadedOpti = action.payload['opti'];

			return {
					...state,
					currentOpti: loadedOpti ? loadedOpti : state.currentOpti,
					chargeOpti: pieces,
					chargeSheetOpti: sheets,
					error: ''
				};

	  case OptiActitonTypes.ChargeOptiFail:

			console.log('--> Entrando en acción ChargeOptiFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					chargeOpti: [],
					chargeSheetOpti: [],
					error: action.payload
				};

	  case OptiActitonTypes.SetCurrentOpti:

			console.log('--> Entrando en acción SetCurrentOpti.');
			console.log(action.payload);

			if (action.payload !== null) {

				return {
					...state,
					currentOpti: action.payload
				};
			} else {
				return {
					...state,
					currentOpti: initialOptiItem
				};
			}
			
	  case OptiActitonTypes.DeleteOptiSuccess:

			console.log('--> Entrando en acción DeleteOptiSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> La optimización que se ha borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.optiList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de optimizaciones:');
					console.log(filterList);

					return {
						...state,
						optiList: filterList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La optimización a eliminar está vacía.');

				return {
					...state,
					error: 'No se ha podido eliminar la optimización.'
				};
			}

		case OptiActitonTypes.DeleteOptiFail:

			console.log('--> Entrando en acción DeleteEaselSuccess.');

			return {
					...state,
					error: action.payload
				};
				
		case OptiActitonTypes.DivideLotSuccess:

			console.log('--> Entrando en acción DivideLotSuccess. => Payload = ');
			console.log(action.payload);
			
			return {
					...state,
					divideLotList: action.payload,
					error: ''
				};

	  case OptiActitonTypes.DivideLotFail:

			console.log('--> Entrando en acción DivideLotFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					divideLotList: [],
					error: action.payload
				};


		default:
			return state;
	}
}
